document.addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector('body');
  const modalVideo = document.querySelector('.banner-video-modal');
  const playButton = document.querySelector('.main-banner .play-button');

  
  if(modalVideo) {
    // fix the modal video to the final to the body
    body.appendChild(modalVideo);

    // Click to Open the video
    playButton.addEventListener('click', () => {
      modalVideo.classList.toggle('active');
    });

    // Close Modal
    modalVideo.addEventListener('click', (e) => {
      const targetElem = e.target;

      if(targetElem.classList.contains('et_pb_code_inner') || targetElem.classList.contains('banner-video-modal')) {
        modalVideo.classList.toggle('active');
      }
    });
  }
  

  
});


// WEBPACK FOOTER //
// ./src/js/elements/banner.js